import type { ReactNode } from 'react';
import { cn } from '../foundation/cn';

export interface ErrorStateProps {
  readonly title?: string;
  readonly description?: string;
  readonly action?: ReactNode;
  readonly className?: string;
}

export function ErrorState({
  title = 'დაფიქსირდა შეცდომა',
  description,
  action,
  className,
}: ErrorStateProps): JSX.Element {
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center justify-center gap-2 p-8 text-center',
        className,
      )}
    >
      <p className="font-medium text-danger">{title}</p>
      {description !== undefined && <p className="text-sm text-fg-muted">{description}</p>}
      {action !== undefined && <div className="mt-2">{action}</div>}
    </div>
  );
}
